import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../_helpers';

// create slice

const name = 'payee';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const payeeActions = { ...slice.actions, ...extraActions };
export const payeeReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        payee: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/user`;

    return {
        getAll: getAll()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(`${baseUrl}/GetPayee`),
            { condition: (_, { getState }) => !Array.isArray(getState().payee.payee) }
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll()
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;
        return {
            [pending]: (state) => {
                state.payee = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.payee = action.payload;
            },
            [rejected]: (state, action) => {
                state.payee = { error: action.error };
            }
        };
    }
}
